<template>
  <div>
    <panel-header>
      <back-link slot="arrow">
        <panel-header-back-arrow/>
      </back-link>
      <span slot="text">{{ category.title }}</span>
    </panel-header>

    <div class="row">
      <div class="col-12">
        <div class="white-wrapper">
          <span class="title">Приметы лунного дня &mdash; {{ category.title.toLowerCase() }}</span>
          <p class="simple-text" v-for="s in this.sentences" :key="s.length + Math.random()">{{ s }}</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import stringHelper from "@/lib/string";
import PanelHeader from "@/components/PanelHeader/PanelHeader";
import BackLink from "@/components/_Utlis/BackLink";
import PanelHeaderBackArrow from "@/components/PanelHeader/PanelHeaderBackArrow";

export default {
  name: "MoonPredictionShow",
  components: {PanelHeaderBackArrow, BackLink, PanelHeader},
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sentences: []
    }
  },
  created() {
    this.sentences = stringHelper.generateText(this.category.textFull);
  },
}
</script>

<style lang="scss" scoped>
.title {
  display: block;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 14px;
}

.simple-text {
  font-size: 14px;
}

.icon {
  margin-top: 14px;
  animation: rolling 3s infinite;
}

@keyframes rolling {
  0% {
    transform: rotate(15deg);
  }
  50% {
    transform: rotate(-15deg);
  }
  100% {
    transform: rotate(15deg);
  }
}

</style>